import { Button, Swiper, SwiperSlide, f7 } from 'framework7-react';
import { FC } from 'react';
import style from './CoatingAboutStyle.module.css';
import ClearPeeling1 from '@/assets/images/coating/clear_peeling_1.png';
import ClearPeeling2 from '@/assets/images/coating/clear_peeling_2.png';
import { paths } from '@/config/paths';
import { f7CustomBack } from '@/utils/utils';

type AboutContentProps = {
  showLink?: boolean;
};

export const AboutContent: FC<AboutContentProps> = ({ showLink = true }) => {
  const handleClick = () => {
    const coatingIndex = f7.views.main.router.history.findIndex(
      (value) => value === paths.coating,
    );
    if (
      coatingIndex !== -1 &&
      coatingIndex === f7.views.main.router.history.length - 2
    ) {
      f7CustomBack();
    } else {
      f7.views.main.router.navigate(paths.coating);
    }
  };

  return (
    <div className={style['container']}>
      {/* ABOUT */}
      <div className={`${style['section']} ${style['has-bottom-sign']}`}>
        <div className={style['section-head']}>
          <h4>ABOUT</h4>
          <p>ボディコーティングとは</p>
        </div>
        <p className={`${style['paragraph']} ${style['text-center']}`}>
          {
            'BRILAコーティングは、\nプロの施工技術者が手作業で施工する\n本格ガラスコーティングです。\n\n独自開発のコーティング剤により、\n美しい光沢と高い撥水性能を実現。\n紫外線や酸性雨からボディを守り、\nお車の美しさを長期間保ちます。'
          }
        </p>
      </div>

      {/* クリア剥がれ注意事項 */}
      <div className={style['section']}>
        <div className={style['section-head']}>
          <h4>NOTICE</h4>
          <p>クリア塗装の剥がれについて</p>
        </div>
        <p className={`${style['paragraph']} ${style['text-center']}`}>
          {
            '経年劣化や紫外線の影響により、\nボディのクリア塗装が剥がれてしまう\nことがあります。\n\nコーティングを施すことで、\nこのようなダメージを未然に防ぎ、\nお車の美しさを長く保つことができます。'
          }
        </p>
        <div className={style['notice-images']}>
          <div className={style['notice-image']}>
            <img src={ClearPeeling1} alt="クリア剥がれ事例1" />
          </div>
          <div className={style['notice-image']}>
            <img src={ClearPeeling2} alt="クリア剥がれ事例2" />
          </div>
        </div>
        <p className={style['notice-caption']}>
          ▲ クリア塗装が剥がれた状態の事例
        </p>
      </div>

      {/* POINT */}
      <div className={`${style['section']} ${style['bg-sub']}`}>
        <div className={style['section-head']}>
          <h4>POINT</h4>
          <p>BRILAコーティングの3つのポイント</p>
        </div>
        <div className={style['section-point-item']}>
          <div className={style['section-point-icon']}>&#x1F48E;</div>
          <h4>最長5年の長期効果</h4>
          <p className={style['paragraph']}>
            最上位のBRILA
            Exclusiveは3液3層コートにより最長5年間の効果を実現。日々のお手入れの手間を大幅に軽減します。
          </p>
        </div>
        <div className={style['section-point-item']}>
          <div className={style['section-point-icon']}>&#x1F6E1;</div>
          <h4>紫外線・酸性雨からボディを保護</h4>
          <p className={style['paragraph']}>
            独自開発のガラスコーティング剤が、紫外線による色あせや酸性雨によるシミからお車のボディを守ります。
          </p>
        </div>
        <div className={style['section-point-item']}>
          <div className={style['section-point-icon']}>&#x2728;</div>
          <h4>{'プロの施工技術者による\n高品質な仕上がり'}</h4>
          <p className={style['paragraph']}>
            認定を受けた施工技術者が、下地処理から仕上げまで丁寧に手作業で施工。新車のような深い光沢を実現します。
          </p>
        </div>
      </div>

      {/* HOW TO USE */}
      <div className={`${style['section']} ${style['bg-sub']}`}>
        <div className={style['section-head']}>
          <h4>HOW TO USE</h4>
          <p>ご利用の流れ</p>
        </div>

        <Swiper
          className={style['section-compare-swiper']}
          pagination
          navigation
          spaceBetween={50}
        >
          <SwiperSlide>
            <div className={style['section-compare-swiper-item']}>
              <div className={style['section-swiper-step']}>
                <p>STEP</p>
                <span>01</span>
              </div>
              <div className={style['section-swiper-content']}>
                <h4>コース選択・予約申請</h4>
                <p>
                  アプリでコーティングコースとオプションを選択し、ご希望の日時で予約を申請します。
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={style['section-compare-swiper-item']}>
              <div className={style['section-swiper-step']}>
                <p>STEP</p>
                <span>02</span>
              </div>
              <div className={style['section-swiper-content']}>
                <h4>日程確定・ご来店</h4>
                <p>
                  担当者が日程を確定後、所定のヤマダデンキ店舗へお車でお越しください。
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={style['section-compare-swiper-item']}>
              <div className={style['section-swiper-step']}>
                <p>STEP</p>
                <span>03</span>
              </div>
              <div className={style['section-swiper-content']}>
                <h4>施工</h4>
                <p>
                  プロの施工技術者が下地処理・コーティング塗布・乾燥まで丁寧に施工します。メニューにより60〜450分程度で完了します。
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={style['section-compare-swiper-item']}>
              <div className={style['section-swiper-step']}>
                <p>STEP</p>
                <span>04</span>
              </div>
              <div className={style['section-swiper-content']}>
                <h4>施工完了・お引き渡し</h4>
                <p>
                  施工完了後、仕上がりをご確認いただきお車をお引き渡しします。
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      {/* PRICE */}
      <div className={style['section']}>
        <div className={style['section-head']}>
          <h4>PRICE</h4>
          <p>コース別価格</p>
        </div>
        <p className={style['section-price']}>
          お車の状態やご希望に合わせて5つのコースからお選びいただけます。
        </p>

        {/* Exclusive */}
        <div
          className={`${style['section-price-item']} ${style['theme-gold']}`}
        >
          <div className={style['section-price-item-head']}>
            <h4>BRILA Exclusive</h4>
            <p>3液3層コート / 効果期間5年</p>
          </div>
          <div className={style['section-price-item-content']}>
            <p className={style['section-course-desc']}>
              3液3層コートによる最高級コーティング。最長5年の効果で深い光沢と強力な保護を実現します。
            </p>
            <div className={style['section-price-list-group']}>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>Sedan</h4>
                  <p>セダン・コンパクト等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    150,000<span>円</span>
                  </h4>
                </div>
              </div>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>SUV / MPV</h4>
                  <p>SUV・ミニバン等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    158,000<span>円</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className={style['section-price-item-note']}>※税込価格</div>
          </div>
        </div>

        {/* Premium */}
        <div
          className={`${style['section-price-item']} ${style['theme-silver']}`}
        >
          <div className={style['section-price-item-head']}>
            <h4>BRILA Premium</h4>
            <p>2液2層コート / 効果期間5年</p>
          </div>
          <div className={style['section-price-item-content']}>
            <p className={style['section-course-desc']}>
              2液2層コートによるプレミアムコーティング。高い光沢性と耐久性を兼ね備えたバランスの良いコースです。
            </p>
            <div className={style['section-price-list-group']}>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>Sedan</h4>
                  <p>セダン・コンパクト等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    120,000<span>円</span>
                  </h4>
                </div>
              </div>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>SUV / MPV</h4>
                  <p>SUV・ミニバン等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    128,000<span>円</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className={style['section-price-item-note']}>※税込価格</div>
          </div>
        </div>

        {/* RED LINE */}
        <div
          className={`${style['section-price-item']} ${style['theme-bronze']}`}
        >
          <div className={style['section-price-item-head']}>
            <h4>BRILA RED LINE</h4>
            <p>2液1層コート / 効果期間3年</p>
          </div>
          <div className={style['section-price-item-content']}>
            <p className={style['section-course-desc']}>
              2液1層コートによるスタンダードコーティング。効果期間3年で、コストパフォーマンスに優れたコースです。
            </p>
            <div className={style['section-price-list-group']}>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>Sedan</h4>
                  <p>セダン・コンパクト等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    80,000<span>円</span>
                  </h4>
                </div>
              </div>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>SUV / MPV</h4>
                  <p>SUV・ミニバン等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    88,000<span>円</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className={style['section-price-item-note']}>※税込価格</div>
          </div>
        </div>

        {/* BLUE LINE */}
        <div
          className={`${style['section-price-item']} ${style['theme-silver']}`}
        >
          <div className={style['section-price-item-head']}>
            <h4>BRILA BLUE LINE</h4>
            <p>2液1層コート / 効果期間1年</p>
          </div>
          <div className={style['section-price-item-content']}>
            <p className={style['section-course-desc']}>
              エントリーコーティング。まずはコーティングを試してみたい方におすすめの手軽なコースです。
            </p>
            <div className={style['section-price-list-group']}>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>Sedan</h4>
                  <p>セダン・コンパクト等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    58,000<span>円</span>
                  </h4>
                </div>
              </div>
              <div className={style['section-price-list']}>
                <div className={style['section-price-list-left']}>
                  <h4>SUV / MPV</h4>
                  <p>SUV・ミニバン等</p>
                </div>
                <div className={style['section-price-list-right']}>
                  <h4>
                    66,000<span>円</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className={style['section-price-item-note']}>※税込価格</div>
          </div>
        </div>

        <p className={style['section-price']}>
          ※磨きオプション（60分/150分）を追加すると料金が変わります。
          <br />
          詳しくは予約画面でご確認ください。
        </p>
      </div>

      {showLink && (
        <div className={style['section']}>
          <Button
            fill
            round
            style={{ background: '#2c4a7c' }}
            onClick={handleClick}
          >
            ボディコーティングを予約する
          </Button>
        </div>
      )}
    </div>
  );
};
